import React from 'react'
import { KeywordMatchTypes } from '../../config'
import { BaseBadge } from './BaseBadge'

const eventModeOptions = {
    [KeywordMatchTypes.Exact]: { intent: 'success', text: 'Exact' },
    [KeywordMatchTypes.Phrase]: { intent: 'primary', text: 'Phrase' },
    [KeywordMatchTypes.Broad]: { intent: 'warning', text: 'Broad' },
}

export const KeywordMatchTypeBadge = ({ match_type, className }) => {
    return <BaseBadge options={eventModeOptions} value={match_type} className={className} />
}
